
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { postData } from "../../../../../ApiServices/ApiService";
import { logFrontendException } from "../../../../../Utils/Exception";
import { ORG_CONFIGURATION_CONFIG_CENTER } from "../../../../../ApiServices/BaseURL";
import { validateMobileNumber } from "../../../../../Utils/Validation";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";

const SmsConfigurationController = (data, loading, error, onRefresh) => {
    const [entityId, setEntityId] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [countryCode, setCountryCode] = useState('+91');

    const [saveLoading, setSaveLoading] = useState(false);
    const [saveError, setSaveError] = useState('');
    const [success, setSuccess] = useState('');

    const [entityIdError, setEntityIdError] = useState('');
    const [mobileNoError, setMobileNoError] = useState('');

    const navigator = useNavigate();

    const { setIsLoginPopup } = useTheme();

    const pageName = "SmsConfigurationController";

    useEffect(() => {
        if (data) {
            setEntityId(data?.sms_entity_id || '');
            setMobileNo(data?.sms_mobile_no || '');
        }
        setSaveError(error);
        setSaveLoading(loading);
    }, [data, error, loading]);

    const saveSmsConfig = async () => {
        setSaveLoading(true);
        setSaveError('');
        setSuccess('');
        setEntityIdError('');
        setMobileNoError('');

        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));

        // Validate required fields
        if (!entityId.trim()) {
            setEntityIdError("Entity Id is required.");
            setSaveLoading(false);
            return;
        }
        if (entityId.trim().length > 20) {
            setEntityIdError("Entity Id is need to be within 20 characters.");
            setSaveLoading(false);
            return;
        }
        if (mobileNo) {
            if (!validateMobileNumber(mobileNo)) {
                setMobileNoError("Mobile number must be 10 digits.");
                setSaveLoading(false);
                return
            }
        }

        const payload = {
            op: 'sms',
            action_type: data ? "update_sms_config" : "add_sms_config",
            emp_id_auth: storedUser?.emp_id,
            sms_entity_id: entityId,
            sms_mobile_no: mobileNo,
        };

        console.log("peyload", payload)

        try {
            const response = await postData(ORG_CONFIGURATION_CONFIG_CENTER, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        setSuccess(responseData?.info);
                        setTimeout(() => {
                            onRefresh();
                            setSuccess('');
                        }, 3000);
                    } else {
                        setSaveError(responseData?.info || "Failed to add/update SMS configuration.");
                        logFrontendException(storedUser?.emp_id, pageName, "saveSmsConfig", responseData?.info);
                    }
                } else {
                    setSaveError(responseData?.info || "Unable to add/update SMS configuration.Please try again.");
                    logFrontendException(storedUser?.emp_id, pageName, "saveSmsConfig", responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setSaveError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                logFrontendException(storedUser?.emp_id, pageName, 'saveSmsConfig-Unauthorized', response || '');
            } else {
                setSaveError("Failed to add/update SMS configuration.Please try again.");
                logFrontendException(storedUser?.emp_id, pageName, "saveSmsConfig", responseData);
            }
        } catch (error) {
            setSaveError("Failed to add/update SMS configuration.Please Check your internet connection and try again.");
            logFrontendException(storedUser?.emp_id, pageName, "saveSmsConfig-catch", error);
        } finally {
            setSaveLoading(false);
        }
    };

    const handleCancel = () => {
        navigator('/dashboard');
    }

    return {
        entityId,
        setEntityId,
        mobileNo,
        setMobileNo,
        countryCode,
        setCountryCode,
        saveLoading,
        saveError,
        success,
        saveSmsConfig,
        entityIdError,
        setEntityIdError,
        handleCancel,
        mobileNoError,
        setMobileNoError,
    }
}
export default SmsConfigurationController;